import { render } from "./ExternalSignContent.vue?vue&type=template&id=20c4b41f"
import script from "./ExternalSignContent.vue?vue&type=script&lang=js"
export * from "./ExternalSignContent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__